module.exports = __webpack_public_path__ + "static/img/f2.5e48837.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/f2.png
// module id = FUjI
// module chunks = 0